var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello text-center pt-5"},[_c('h1',{attrs:{"id":"title"}},[_vm._v("Hello World!")])])}]

export { render, staticRenderFns }